module.exports = __webpack_public_path__ + "img/5.b5c69ffc.jpg";